module.exports = __webpack_public_path__ + "static/media/pella_logo.f1143531.png";